import React, { ComponentProps, forwardRef } from 'react';

import { Link as RouterLink } from 'components/RouterLink';

import { PrimaryButton } from './PrimaryButton';

export const PrimaryButtonRouterLink = forwardRef<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  ComponentProps<typeof PrimaryButton>
>((props, ref) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <PrimaryButton component={RouterLink} type={undefined} ref={ref} {...props} />
));
